'use client'

import type { HeaderControlCounterProps } from '@maestro/commerce-blocks/components/header-controls/header-controls.types'

import classNames from 'classnames'
import { useEffect, useState } from 'react'

export default function HeaderControlCounter(props: HeaderControlCounterProps) {
  const { count } = props
  const [isUpdating, setIsUpdating] = useState(false)

  useEffect(() => {
    setIsUpdating((prev) => {
      if (!prev && count > 0) {
        setTimeout(() => {
          setIsUpdating(false)
        }, 200)
        return true
      }
      return prev
    })
  }, [count])

  return (
    <i
      aria-hidden="true"
      className={classNames('counter', 'counter--small', {
        ['counter--updating']: isUpdating,
      })}
    >
      {count || ''}
    </i>
  )
}
